import React from 'react';
import uniqueId from '../../../utils/uniqueId';
import Tooltip from '../Tooltip';
import styles from './popupMenuButton.module.scss';

const PopupMenuButton = ({
  children,
  onClick,
  className,
  tooltip = '',
  disabled = false,
}) => {
  const tooltipId = uniqueId('popupButton');

  const handleClick = (e) => {
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  return (
    <>
      <div
        className={`
                    d-flex
                    justify-content-start
                    align-items-center
                    gap-1
                    text-truncate
                    ${styles.popup_menu_button}
                    ${disabled ? styles.disabled : ''}
                    ${className}`}
        onClick={handleClick}
        role="presentation"
        data-for={tooltipId}
        data-tip
      >
        {children}
      </div>
      {tooltip && <Tooltip fixWidth id={tooltipId} info={tooltip} />}
    </>
  );
};

export default PopupMenuButton;
